var React = require('react');

function EtteMobileMenu2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M32.2,0.5c-2.7,0.7-5.5-0.7-7.6-0.5c-2.2,0.2-4.4,0.4-7.2,0.9C14.8,1.3,9.6,0.5,6.9,0.2C5.2,0,3.5,0.2,1.8,0.6\n\tC1.2,0.7,0.3,0.6,0,2.1c2.4-0.4,4.8-0.2,7.2-0.3c3.2-0.1,6.4,1.5,9.6,1.6c4.5,0.2,8.8-0.7,11.5-0.8C31.6,2.4,32.2,0.5,32.2,0.5"}));
}

EtteMobileMenu2.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 32.2 3.4"};

module.exports = EtteMobileMenu2;

EtteMobileMenu2.default = EtteMobileMenu2;
